import { Component } from "@angular/core";
import { ApicallService } from "@core-services/apicall.service";
import { InfoService } from "@core-services/info.service";
import { QrModalComponent } from "@modules/main/components/qr-modal/qr-modal.component";
import { Security2FAModalComponent } from "../../models/interfaces/security-2fa-modal.component";
import * as FileSaver from "file-saver";
import { Helper } from "@helpers/functions";
import { UserService } from "@main-services/user.service";
import { currentDate } from "@helpers/date";
import { ConfirmModalService } from "@core-services/confirm-modal.service";
import { NewProfileFacade } from "@modules/main/components/profile/new-profile/state/new-profile.facade";

@Component({
	templateUrl: "./security-2fa-enable-modal.component.html",
	styleUrls: ["./security-2fa-enable-modal.component.scss"],
	standalone: false
})
export class Security2FAEnableModalComponent extends Security2FAModalComponent {
	public readonly steps: number = 7;
	public recoveryInputValue: string;
	public recoveryInputError: string;
	public profile$ = this.profileFacade.getProfile$();

	public constructor(
		protected userService: UserService,
		protected apicallService: ApicallService,
		protected infoService: InfoService,
		protected profileFacade: NewProfileFacade,
		protected confirmModalService: ConfirmModalService
	) {
		super(userService, apicallService, infoService, profileFacade, confirmModalService);
	}

	public onClickContinue(): void {
		this.cdr.markForCheck();
		switch (this.currentStep) {
			case 1:
				this.verifyUserPassword();
				break;
			case 2:
				this.verifySmsCode();
				break;
			case 3:
				this.increaseStep();
				break;
			case 4:
				this.verifyRecoveryCode();
				break;
			case 5:
				this.increaseStep();
				break;
			case 6:
				this.pinCodeVerification(true);
				break;
			case 7:
				this.closeAll();
				break;
			default:
				break;
		}
	}

	public verifyRecoveryCode(): void {
		if (this.recoveryInputValue === this.secretKey) {
			this.increaseStep();
		} else {
			this.recoveryInputError = "security_settings_2fa_enable_modal_step_input_recovery_error";
		}
	}

	public openQr(): void {
		this.modalService.showModal(QrModalComponent, this.QRdata);
	}

	public onClickDownloadPDF(): void {
		const date = currentDate();
		this.apicallService.downloadFilePost("user/download2fa-pdf/", this.secretKey).subscribe(
			(a) => FileSaver.saveAs(a, "Bitpanda_2FA_Code_" + date + ".pdf"),
			(error) => Helper.handleError(error)
		);
	}
}
